import { SignInButton, SignUpButton } from "components/Button";
import HighlightedSpan from "components/HighlightedSpan";
import SidebarNavigation from "features/History/components/SidebarNavigation";
import NewThreadButton from "features/NewThreadButton";
import useLabels from "hooks/useLabels";
import { useSidebar } from "hooks/useSidebar";
import { useAppSelector } from "hooks/useStore";

function SignedOutContent() {
  const { toggleSidebar } = useSidebar();
  const isMobile = useAppSelector((state) => state.setting.isMobile);

  const [sidebarLabels] = useLabels("screens.sidebar");

  const handleOnNavigate = () => {
    if (isMobile) {
      toggleSidebar();
    }
  };

  return (
    <div className="flex flex-col pb-3 w-full h-full">
      <div className="flex flex-col gap-1">
        <NewThreadButton asSidebarNavItem />
        <SidebarNavigation onNavigate={handleOnNavigate} />
      </div>
      <div className="flex flex-col flex-1 px-4 justify-center items-center w-full">
        <div className="flex flex-col flex-1 gap-4 pt-4">
          <hr className="border-border-base" />
          <h1 className="h2-md pr-8 leading-[1.3]">{sidebarLabels.tagline}</h1>
          <p className="leading-[1.4]">
            {sidebarLabels.description["sentence-1"]}
          </p>

          <p className="leading-normal">
            <span className="mr-1">
              {sidebarLabels.description["sentence-2"]}
            </span>
            <HighlightedSpan className="py-1 bg-accent-bg-subtle">
              <span>
                {sidebarLabels.description["sentence-2-highlight-part-1"]}
              </span>
              <span className="ml-1">
                {sidebarLabels.description["sentence-2-highlight-part-2"]}
              </span>
              <img
                alt="quote bubble"
                src="/icons/quote-bubble.svg"
                className="inline-block ml-1 w-6 h-6 align-middle"
              />
            </HighlightedSpan>
          </p>
          <p className="pr-2 leading-normal">
            <span className="mr-1">
              {sidebarLabels.description["sentence-3"]}
            </span>
            <HighlightedSpan className="py-1 bg-chart-green-faint">
              <span>{sidebarLabels.description["sentence-3-highlight"]}</span>
              <img
                alt="document"
                src="/icons/document-star.svg"
                className="inline-block ml-1 w-6 h-6 mb-1 align-middle"
              />
            </HighlightedSpan>
          </p>
        </div>
        <div
          onClick={handleOnNavigate}
          className="flex flex-col gap-2 justify-center w-full mt-4"
        >
          <SignUpButton />
          <SignInButton />
        </div>
      </div>
    </div>
  );
}

export default SignedOutContent;
